export const LOCAL_URL = "http://local-dev.hoxton.co:4010";
export const PROD_URL = "https://local-dev.hoxton.co:4010";

function getHoxtonCliUri() {
    if (window.location.hostname === "local-dev.hoxton.co") {
        return LOCAL_URL;
    }

    return PROD_URL;
}

export default {
    appConfig: {
        RENDERER_SERVICE: "https://renderer.hoxton.co"
    },
    getHoxtonCliUri
};
